import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Box, Image, Text, SvgIcon, ButtonFilled } from 'Components/Base';

const EmptyCourses = ({ title, imageUrl, description, btnLabel, onClickBtn }) => {
  return (
    <Flex flexDirection={'column'} alignItems={'center'}>
      {imageUrl ? (
        <Image src={imageUrl} width={'128px'} />
      ) : (
        <SvgIcon icon={SvgIcon.ICON_LIST.VIDEO_LIBRARY} width={120} height={120} />
      )}
      <Box pt={5} />
      <Text textStyle={'heading4'} fontWeight={'medium'}>
        {title}
      </Text>
      <Box pt={3} />
      <Text
        textStyle={'body2'}
        fontWeight={'normal'}
        color={'greyscale.grey3'}
        textAlign={'center'}
      >
        {description}
      </Text>
      {typeof onClickBtn === 'function' && (
        <ButtonFilled py={2} mt={7} borderRadius={'100px'} onClick={onClickBtn}>
          {btnLabel}
        </ButtonFilled>
      )}
    </Flex>
  );
};

EmptyCourses.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  btnLabel: PropTypes.string,
  onClickBtn: PropTypes.func,
  imageUrl: PropTypes.string,
};

export default EmptyCourses;
